var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChipLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 18,
  viewBox: "0 0 27 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 0.00476074,
  width: 27,
  height: 17.9951,
  rx: 5,
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 5.80583H10.0167L10.0329 5.88129C10.1228 6.3037 10.2311 6.90426 10.3033 7.61077C10.4241 8.79289 10.4399 10.2364 10.1228 11.6291H0V12.9291H9.93345L9.94313 13.0193L12.9431 18.0004H14.0568L17.0568 13.0193L17.0637 12.9291H26.9997V11.6291H16.8725C16.809 11.3418 16.7443 10.9818 16.6958 10.5549C16.5665 9.41589 16.5527 7.79726 16.9883 5.80583H26.9997V4.50583H16.9246L14.0478 0H12.9521L10.0752 4.50583H0V5.80583ZM11.2009 5.15855C11.2302 5.27711 11.2659 5.42934 11.3045 5.61068C11.4021 6.06928 11.5188 6.71682 11.5966 7.47866C11.7432 8.9138 11.7568 10.8005 11.2092 12.6017L13.4999 16.4052L15.7867 12.6083C15.7614 12.5271 15.7332 12.431 15.7035 12.3204C15.602 11.943 15.483 11.3972 15.4041 10.7016C15.2521 9.3622 15.2489 7.47088 15.802 5.16317L13.4999 1.55766L11.2009 5.15855Z",
  fill: "black",
  fillOpacity: 0.56
})));
export { SvgChipLight as ReactComponent };
export default __webpack_public_path__ + "static/media/chip-light.9a567772.svg";